const E2E_PREFIX = 'tradevan-create';

export default E2E_PREFIX;
